<template>
  <el-time-picker class="base-time-picker" v-model="localModel" :value-format="valueFormat" :format="format" />
</template>

<script>
export default {
  name: 'BaseTimePicker',
  props: {
    value: { type: [Date, String], default: '00:00:00'},
    valueFormat: { type: String, default: '00:00' },
    format: { type: String, default: "hh:mm A"}
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>

<style>
.base-time-picker.el-date-editor.el-input {
  margin: 0 !important;
  width: 100% !important;
}
</style>
